import type { StudentSummary } from '@/services/api/student-summary';
import { API_BASE_URL, fetchApi } from '@/services/api-client';

export const ADMIN_ALLERGY_CHANGES_PATH = '/admin/allergy-change-requests';

export type AllergyItem = { label: string; severe: boolean };
export type AllergyChangeStatus = 'pending' | 'approved' | 'rejected';

export type AllergyChangeRequest = {
  id: string;
  studentId: string;
  student: StudentSummary | null;
  submittedByParentId: string | null;
  submittedByParentName: string | null;
  status: AllergyChangeStatus;
  proposedAllergies: AllergyItem[];
  proposedDietaryNote: string | null;
  snapshotAllergies: AllergyItem[];
  snapshotDietaryNote: string | null;
  requiresDocument: boolean;
  hasDocument: boolean;
  documentOriginalName: string | null;
  appliedAllergies: AllergyItem[] | null;
  appliedDietaryNote: string | null;
  decisionMessage: string | null;
  reviewerId: string | null;
  reviewedAt: string | null;
  createdAt: string;
};

export type ApproveAllergyChangeData = { allergies: AllergyItem[]; dietaryNote: string | null; message?: string };
export type RejectAllergyChangeData = { message?: string };

export const adminAllergyChangeRequestsApi = {
  list: (status?: AllergyChangeStatus) =>
    fetchApi<AllergyChangeRequest[]>(`${ADMIN_ALLERGY_CHANGES_PATH}${status ? `?status=${status}` : ''}`),
  detail: (id: string) => fetchApi<AllergyChangeRequest>(`${ADMIN_ALLERGY_CHANGES_PATH}/${id}`),
  approve: (id: string, data: ApproveAllergyChangeData) =>
    fetchApi<AllergyChangeRequest>(`${ADMIN_ALLERGY_CHANGES_PATH}/${id}/approve`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  reject: (id: string, data: RejectAllergyChangeData) =>
    fetchApi<AllergyChangeRequest>(`${ADMIN_ALLERGY_CHANGES_PATH}/${id}/reject`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  documentUrl: (id: string): string => `${API_BASE_URL}${ADMIN_ALLERGY_CHANGES_PATH}/${id}/document`,
};
